import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { ChampionListMemberComponent } from '../champion-list-member/champion-list-member.component';
import { DataService } from '../data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-champion-list',
  templateUrl: './champion-list.component.html',
  styleUrls: ['./champion-list.component.scss']
})
export class ChampionListComponent implements OnInit {

  /** @var {ViewContainerRef} The view container that holds all the ChampionListMemberComponents */
  @ViewChild("memberContainer", {static: false, read: ViewContainerRef }) memberContainer: ViewContainerRef;
  subscription: Subscription;



  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private dataService: DataService
  ) { }



  ngOnInit() { }

  ngAfterViewInit() {
    this.subscription = this.dataService.observeChampionData().subscribe(ready => {
      if (ready)
        this.generateChampionPoolItems();
    })
    
  }

  /**
   * Call addChampionPoolItem() for all champions
   */
  public generateChampionPoolItems() {
    // Get data of the champions from ChampionManagerService
    // Create a ChampionPoolItemComponent for each champion
    var championData = this.dataService.getChampionData();
    for (let championId in championData) {
      this.addChampionPoolItem(championId);
    }
  }



  /**
   * Add a new ChampionListMemberComponent that will represent one champion.
   * @param {string} championId A champion's ID
   */
  public addChampionPoolItem(championId: string) {
    // Create the ChampionPoolItemComponent and add a reference of it to the ChampionManagerService
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ChampionListMemberComponent);
    const componentRef = this.memberContainer.createComponent(componentFactory);
    componentRef.changeDetectorRef.detectChanges();
    const championPoolItemComponent = <ChampionListMemberComponent> componentRef['instance'];
    // Set attributes for the ChampionPoolItemComponent
    championPoolItemComponent.setId(championId);
    championPoolItemComponent.setName(this.dataService.getChampionData()[championId]['name']);
    //console.log(this.dataService.getChampionData()[championId]['name']);
  }

}
